/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import baustein from "baustein";
import CountryOverlay from "components/overlays/country-overlay";

const JOIN_SELECTOR = ".app-pre-header-bar__signup";
const LOGIN_SELECTOR = ".app-pre-header-bar__login";
const COUNTRY_PICKER_SELECTOR = ".app-pre-header-bar__country-picker";

export default baustein.register("app-pre-header-bar", {
    defaultOptions: {
        enableCountryPicker: false
    },

    setupEvents(add) {
        add("click", JOIN_SELECTOR, this._onSignUpPrompt);
        add("click", LOGIN_SELECTOR, this._onLoginPrompt);

        if (this.options.enableCountryPicker) {
            add("click", COUNTRY_PICKER_SELECTOR, this._onCountryPickerClick);
        }
    },

    /**
     * When the component is removed we can release all global handlers that may have been set.
     */
    onRemove() {
        this.releaseAllGlobalHandlers();
    },

    /**
     * Handler for click events on the country picker menu.
     *
     * @param {Event} event
     */
    _onCountryPickerClick(event) {
        event.stopPropagation();
        event.preventDefault();

        const countryOverlay = new CountryOverlay();
        countryOverlay.appendTo(document.body);
        countryOverlay.open();
    },

    /**
     * Handler for click events on the "sign up" header link.
     */
    _onSignUpPrompt(event) {
        event.preventDefault();

        // send it up to the lyst-app to open
        this.emit("triggerSignup", {
            path: "/account/register/",
            queryParams: {
                next: [window.location.pathname + window.location.search],
                product_id: [],
                type: ["signup"]
            },
            formType: "signup",
            pageType: "header",
            pageSubType: "signup_or_login"
        });
    },

    /**
     * Handler for click events on the "sign in" header link.
     */
    _onLoginPrompt(event) {
        event.preventDefault();

        // send it up to the lyst-app to open
        this.emit("triggerSignup", {
            path: "/account/login/",
            queryParams: {
                next: [window.location.pathname + window.location.search],
                product_id: [],
                type: ["sign_in"]
            },
            formType: "sign_in",
            pageType: "header",
            pageSubType: "signup_or_login"
        });
    }
});

